<template>
  <div class="row mt-0">
    <div class="col-md-12 pt-0">
      <div class="card mt-2 mb-0">
        <div>
          <v-container class="pt-0 pb-0">
            <v-layout justify-space-between>
              <v-flex md5 sm12>
                <v-dialog v-model="buscar" width="900" persistent v-if="buscador">
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-2" icon color="primary" v-on="on">
                      <v-icon>mdi-magnify</v-icon>Buscar
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <v-btn
                        color="primary"
                        text
                        @click="buscar = false; search=''; indicadores=[]"
                      >Cerrar</v-btn>
                      <v-spacer></v-spacer>
                      <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Buscar"
                        single-line
                        hide-details
                        @keyup="filtrar"
                      ></v-text-field>
                    </v-card-title>
                    <v-card-text>
                      <div v-if="indicadores">
                        <v-data-table
                          :no-data-text="gnodata"
                          :headers="headersindicador"
                          :items="indicadores"
                          class="elevation-2"
                          hide-default
                          :items-per-page="10"
                        >
                          <template v-slot:item.action="{ item }">
                            <div v-if="item.finalizado === true">
                              <v-icon small class="mr-2" @click="verdetalle(item)">remove_red_eye</v-icon>
                            </div>
                            <div v-else>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-icon small color="red" class="mr-2" v-on="on">remove_red_eye</v-icon>
                                </template>
                                <span>Sin ficha técnica</span>
                              </v-tooltip>
                            </div>
                          </template>
                          <template v-slot:item.avancemostrar="{ item }">
                            <div v-if="item.avancemostrar !== '-'">
                              <span small class="mr-2">{{item.avancemostrar}}</span>
                            </div>
                            <div v-else>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <span v-on="on" class="mr-2">{{item.avancemostrar}}</span>
                                </template>
                                <span>Entidad no registró avance</span>
                              </v-tooltip>
                            </div>
                          </template>
                        </v-data-table>
                        
                      </div>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-flex>
             <v-flex md6>
                <v-layout wrap>
                  <v-layout align-center justify-end row fill-height>
                    <div
                      style="display: table;   justify-content: center;   align-items: center; height: 40px"
                    >
                      <p
                        style="text-align:right; display: table-cell;	vertical-align: middle; white-space: pre-wrap;"
                      >Filtrar por:</p>&nbsp;
                    </div>
                    <v-btn-toggle>
                      <div v-for="(btn, idx) in gbotones" :key="idx">
                        <v-tooltip v-if="btn.tool !== ''" bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              :key="'b' + idx"
                              :value="btn.caption"
                              v-on="on"
                              large
                              :color="btn.color"
                              :disabled="btn.disabled"
                              elevation="2"
                              v-on:click="Validarestado(btn)"
                            >{{ btn.caption }}</v-btn>
                          </template>
                          <span>{{ btn.tool }}</span>
                        </v-tooltip>
                        <v-btn
                          v-else
                          :key="'b' + idx"
                          :value="btn.caption"
                          large
                          :color="btn.color"
                          :disabled="btn.disabled"
                          elevation="2"
                          v-on:click="Validarestado(btn)"
                        >{{ btn.caption }}</v-btn>
                      </div>
                    </v-btn-toggle>
                    <v-overflow-btn
                      :items="periodos"
                      :disabled="vigenciainactiva"
                      :label="textField"
                      :value="selectOption"
                      class="ml-2 no-details"
                      v-on:change="seleccionarperiodo"
                    />
                  </v-layout>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import store from "../../stores/index.js";
export default {
  name:"BarraNav",
  props: {
    buscador: Boolean,
    setbtndefault: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      periodos: [],
      selectOption: 0,
      textField: "",
      buscar: false,
      indicadores: [],
      headersindicador: [
        { text: "Código", value: "codigo", fixed: true, width: "100px" },
        { value: "nombre", text: "Nombre" },
        { value: "nombreentidad", text: "Responsable", width: "30%" },
        { text: "Detalle", value: "action", sortable: false, align: "center" }
      ],
      search: null,
      //Parametros de paginación
    };
  },
  mounted() {
    this.periodos = [];
    for (let [, value1] of Object.entries(this.$store.state.periodo.periodos)) {
      this.periodos.push({ value: value1.idperiodo, text: value1.nombre });
    }
    this.selectOption = this.gperiodo;
  },
  watch: {
     setbtndefault: function () {
      if (this.setbtndefault == 3)
      {
        let botones= { caption: "Por vigencia", state: false, disabled:false, id: 3 , color:"secondary", reduce:"V", tool:"Indicadores en ejecución en el año consultado"};
        this.Validarestado(botones);
      }if (this.setbtndefault == 1)
      {
        let botones= {caption: "General", state: true, disabled:false, id: 1 , color:"primary", reduce:"G", tool:"Corresponde al avance acumulado a la fecha."};
        this.Validarestado(botones);
      }
      
    },
    vigencias: function() {
      this.periodos = [];
      let i = 0;
      for (let [, value1] of Object.entries(
        this.$store.state.periodo.periodos
      )) {
        if (i === 0) {
          this.selectOption = value1.idperiodo;
          let payload = { idperiodo: this.selectOption };
          this.$store.dispatch("barra/put_periodo", payload);
        }
        i = i + 1;
        this.periodos.push({ value: value1.idperiodo, text: value1.nombre });
      }
    },
    botonactual: function(valornuevo) {
      let payload = valornuevo === 3 ? "V" : valornuevo === 2 ? "C" : "";
      switch (payload) {
        case "V":
          this.textField = "Vigencia";
          break;
        case "C":
          this.textField = "Periodo";
          break;
        case "":
          this.textField = "";
          break;
      }
      if (payload != "") {
        const para = { periodicidad: payload };
        this.$store.dispatch("aperiodicidad", { params: para, data: {} });
      } else {
        this.selectOption = 0;
        let payload2 = { idperiodo: this.selectOption };
        this.$store.dispatch("barra/put_periodo", payload2);
        this.periodos = [];
      }
    },
    gperiodo: function() {
      this.selectOption = this.gperiodo;
    }
  },
  created() {
    if (this.buscador) {
      this.get_indicadoresreducido();
    }
  },
  methods: {
    ...mapActions(["get_indicadoresreducido"]),
    Validarestado(btn) {
      let payload = { botonnuevo: btn.id };
      this.$store.dispatch("barra/aseleccionar", payload);
    },
    seleccionarperiodo(opc) {
      let payload = { idperiodo: opc };
      this.$store.dispatch("barra/put_periodo", payload);
    },
    backLink() {
      this.$router.go(-1);
    },
    filtrar() {
      if (this.search !== "") {
      this.indicadores = this.gindicadoresreducido.filter(
        p =>
          p.nombrefiltro.toUpperCase().indexOf(this.search.toUpperCase()) !==
            -1 ||
          p.nombre.toUpperCase().indexOf(this.search.toUpperCase()) !== -1 ||
          p.codigo.toUpperCase().indexOf(this.search.toUpperCase()) !== -1
      );
      } else {
          this.indicadores =[];
      }
    },
    verdetalle(item) {
      let payload = { nombre: "idpunto", valor: item.idpunto.toString() };
      store.dispatch("navegacion/set_parametro", payload);
      payload = { nombre: "idpilar", valor: item.idpilar.toString() };
      store.dispatch("navegacion/set_parametro", payload);
     let global = JSON.parse(unescape(process.env.PACKAGE_JSON)).global;
      let env = global[global.env];
      this.$aes.setKey(env.path.secret);
       let cifra = this.$aes.encrypt(item.idindicador.toString());
      let temporal =   Math.random().toString(36).substring(2, 6) + cifra  +  Math.random().toString(36).substring(2, 6);
         let encrypted = this.$aes.encrypt(temporal);
     encrypted = encrypted.replace(/\//g, "AbcYq")
      encrypted = encrypted.replace(/\+/g, "qYcbA");
      this.$router.push("/detalleindicador/" + encrypted);
    }
  },
  computed: {
    ...mapGetters("barra", ["gbotones", "gperiodo"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    ...mapGetters(["gindicadoresreducido"]),
    vigencias() {
      return this.$store.state.periodo.periodos;
    },
    botonactual() {
      return this.$store.state.barra.botonactual;
    },
    vigenciainactiva() {
      return this.botonactual === 1;
    }
  },
};
</script>
